import TransfersAppConfig from './diller-transfers/DillerTransfersAppConfig';
import OrderAppConfig from './order/ordersAppConfig';
import SAOrderAppConfig from './SA-order/ordersAppConfig';
import SAOrderByDillerAppConfig from './SA-order-by-diller/ordersAppConfig';

const DillerAppConfig = [OrderAppConfig, SAOrderAppConfig, TransfersAppConfig, SAOrderByDillerAppConfig];

export default DillerAppConfig;
